import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AppRoutes } from '../enums/app-routes.enum';

export const rootRedirectGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return router.createUrlTree([`/${AppRoutes.APP}/${AppRoutes.TABS}/${AppRoutes.HOME}`]);
  }
  return router.createUrlTree([`/${AppRoutes.AUTH}/${AppRoutes.LOGIN}`]);
};
